import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/occupations',
    name: RouteEnum.OCCUPATIONS.INDEX,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'admin:occupations.index' */ '~/pages/admin/occupations/index.vue'
        )
      ),
  },
  {
    path: '/occupations/create',
    name: RouteEnum.OCCUPATIONS.CREATE,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'admin:occupations.create' */ '~/pages/admin/occupations/create.vue'
        )
      ),
  },
];
